import * as Yup from 'yup';
import checkoutFormModel from './formModel';

const {
    formField: {
        numeroReferencia,
        fechaNacimiento,
        premium,
    }
} = checkoutFormModel;

export default [
    Yup.object({
        [numeroReferencia.name]: Yup
            .number('Ingrese el número de referencia')
            .required(`${numeroReferencia.requiredErrorMsg}`)
            .typeError("Introduzca únicamente números"),
        [premium.name]: Yup
            .number('Ingrese el valor de la cuota mensual')
            .required(`${premium.requiredErrorMsg}`)
            .integer()
            .typeError("Introduzca únicamente números"),
    }),
    Yup.object({
        [fechaNacimiento.name]: Yup
            .date()
            .max(new Date(Date.now() - 567648000000), "El cliente debe tener al menos 18 años para contratar")
            .required(`${fechaNacimiento.requiredErrorMsg}`),
    }),
];